import {IncomingHttpHeaders} from 'http';
import {ExperimentData} from 'mkt-ssr/lib/experiments';

export const EXPERIMENT_DATA_HEADER = 'x-experiment-data';

export function getExperimentData(
  headers?: IncomingHttpHeaders,
): ExperimentData {
  const experimentDataHeader = headers?.[EXPERIMENT_DATA_HEADER]?.toString();

  let experimentData: ExperimentData = {};

  if (experimentDataHeader) {
    try {
      experimentData = JSON.parse(experimentDataHeader);
    } catch (error) {
      // Unable to access `import {Log} from 'mkt-ssr/lib/server/Log'` nor Sail logging SDKs here
      // eslint-disable-next-line no-console
      console.error(
        `Error parsing experiment data JSON string from "${EXPERIMENT_DATA_HEADER}" header.`,
        error,
      );
    }
  } else {
    // Unable to access `import {Log} from 'mkt-ssr/lib/server/Log'` nor Sail logging SDKs here
    // eslint-disable-next-line no-console
    console.error(
      `Error getting experiment data from "${EXPERIMENT_DATA_HEADER}" header.`,
    );
  }

  return experimentData;
}
